<template>
  <div id="contenedor-listado-desktop">
    <v-data-table :headers="headers" :items="listadoLicitaciones" :items-per-page="20">
      <template v-slot:[`item.numero`]=" { item }">
        <router-link
        :to="{name: 'licitacion', params: { idLicitacion: item.id }}">
          {{ item.numero }}
        </router-link>
      </template>
      <template v-slot:[`item.tipo`]="{ item }">
        <v-chip
        dark
        :color="getTextoyColor(item.tipo).color">
          <span>{{ getTextoyColor(item.tipo).texto }}</span>
        </v-chip>
      </template>
      <template v-slot:[`item.caracter`]="{ item }">
        {{ item.caracter === 1 ? 'NACIONAL' : ''}}
      </template>
      <template v-slot:[`item.normatividad`]="{ item }">
        {{ item.normatividad === 1 ? 'FEDERAL' : 'ESTATAL'}}
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :licitacion="item"></opciones>
      </template>
      <template v-slot:[`item.fechaConvocatoria`]="{ item }">
        <!-- <fecha-humano :fecha="new Date(item.fechaConvocatoria)"></fecha-humano> -->
        {{ new Date(item.fechaConvocatoria).toLocaleDateString() }}
      </template>
      <!-- <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template> -->
      <template v-slot:[`item.objeto`]="{ item }">
        <cortar-texto
        :texto="item.objeto">
        </cortar-texto>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CortarTexto from '@/components/CortarTextos.vue';
import Opciones from './Opciones.vue';
// import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'ListadoLicitacionesDesktop',
  props: {
    listadoLicitaciones: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
    CortarTexto,
    // FechaHumano,
  },
  data() {
    return {
      tiposLicitacion: [
        { id: 1, texto: 'LICITACIÓN PÚBLICA', color: '#43BC82' },
        { id: 2, texto: 'LICITACIÓN RESTINGIDA POR INVITACIÓN', color: '#1E88E5' },
      ],
      headers: [
        {
          text: 'Número de Licitación',
          align: 'start',
          value: 'numero',
          width: '200',
          sortable: false,
        },
        { text: 'Tipo', value: 'tipo', sortable: false },
        {
          text: 'Normatividad', align: 'center', value: 'normatividad', sortable: false,
        },
        {
          text: 'Carácter', align: 'center', value: 'caracter', sortable: false,
        },
        { text: 'Objeto', value: 'objeto', sortable: false },
        { text: 'Número de Convocatoria', value: 'numeroConvocatoria', sortable: false },
        {
          text: 'F. Convocatoria', align: 'center', value: 'fechaConvocatoria', sortable: false,
        },
        { text: 'Estatus', value: 'estatus', sortable: false },
        // { text: 'F. Registro', value: 'createdAt', width: '120' },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
  methods: {
    getTextoyColor(tipo) {
      return this.tiposLicitacion.find((tipoLicitacion) => tipo === tipoLicitacion.id);
    },
  },
};
</script>

<style lang="scss">

</style>
